import { render, staticRenderFns } from "./LocationSelect.vue?vue&type=template&id=4df873cc"
import script from "./LocationSelect.ts?vue&type=script&lang=ts&external"
export * from "./LocationSelect.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports